import React, { useEffect, useRef } from 'react';

const PAYPAL_URL = 'https://www.paypal.com/ncp/payment/WKSNR77WNYPFS';

function AppealPage({ onBack }) {
  const heroRef = useRef(null);

  // Scroll to the appeal header when the page loads
  useEffect(() => {
    const scrollTimer = setTimeout(() => {
      if (heroRef.current) {
        heroRef.current.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }, 100);
    return () => clearTimeout(scrollTimer);
  }, []);

  return (
    <div className="appeal-page">
      <button className="back-btn" onClick={onBack}>← Back</button>

      <div className="appeal-hero" ref={heroRef}>
        <div className="appeal-icon">🍽️</div>
        <h1>Help Keep StoryMeal Free</h1>
        <p className="appeal-subtitle">
          Every story you read here is free — and we want to keep it that way.
        </p>
      </div>

      <div className="appeal-content">
        <section className="appeal-section">
          <h2>📖 Why Your Support Matters</h2>
          <p>
            StoryMeal is a passion project built on the belief that great stories should be
            accessible to everyone, everywhere. We host thousands of stories across dozens of
            genres — from folk tales and fables to modern fiction and poetry.
          </p>
          <p>
            Running a website like this isn't free. Servers, storage, development, and
            maintenance all cost money. Your donations help us:
          </p>
          <ul className="appeal-list">
            <li>🌐 <strong>Keep the lights on</strong> — pay for hosting and infrastructure</li>
            <li>📚 <strong>Keep stories free</strong> — no paywalls, no subscriptions, ever</li>
            <li>✍️ <strong>Support writers</strong> — help authors share their work with the world</li>
            <li>🚀 <strong>Build new features</strong> — improve the reading and writing experience</li>
            <li>🛡️ <strong>Stay independent</strong> — no ads, no tracking, no compromises</li>
          </ul>
        </section>

        <section className="appeal-section appeal-impact">
          <h2>💛 Where Every Dollar Goes</h2>
          <div className="appeal-impact-grid">
            <div className="appeal-impact-item">
              <div className="appeal-impact-emoji">🖥️</div>
              <h3>Servers & Hosting</h3>
              <p>Keeping the site fast and available 24/7</p>
            </div>
            <div className="appeal-impact-item">
              <div className="appeal-impact-emoji">📝</div>
              <h3>Story Storage</h3>
              <p>Preserving thousands of stories for readers</p>
            </div>
            <div className="appeal-impact-item">
              <div className="appeal-impact-emoji">⚙️</div>
              <h3>Development</h3>
              <p>Building new features and fixing bugs</p>
            </div>
            <div className="appeal-impact-item">
              <div className="appeal-impact-emoji">🛡️</div>
              <h3>Security</h3>
              <p>Protecting the site and our community</p>
            </div>
          </div>
        </section>

        <section className="appeal-section appeal-cta-section">
          <h2>🍲 Buy Us a Side Dish</h2>
          <p className="appeal-cta-text">
            Every contribution — big or small — helps us keep StoryMeal running and free for
            readers everywhere. Think of it as buying us a side dish to keep the kitchen cooking.
          </p>

          <div className="appeal-paypal-container">
            <a
              href={PAYPAL_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="paypal-support-btn appeal-paypal-btn"
            >
              <span className="paypal-btn-icon">🍲</span>
              <span className="paypal-btn-text">Buy us a side dish</span>
              <span className="paypal-btn-subtext">via PayPal</span>
            </a>
            <p className="appeal-paypal-note">
              Secure payment via PayPal. One-time or recurring — your choice.
            </p>
          </div>
        </section>

        <section className="appeal-section appeal-thanks">
          <h2>🙏 Thank You</h2>
          <p>
            Whether you donate, write a story, share StoryMeal with a friend, or simply read
            and enjoy — you're part of what makes this community special.
          </p>
          <p>
            From all of us at StoryMeal: <strong>thank you</strong> for keeping stories alive. 💛
          </p>
        </section>
      </div>
    </div>
  );
}

export default AppealPage;